<div class="flex flex-col h-full">
    <div class="grid grid-cols-1 lg:grid-cols-1 items-start gap-8 flex-1 overflow-y-auto px-20">
        @if(!_orderWizardService.loading$()) {
            <ng-container [ngTemplateOutlet]="component_loaded"></ng-container>
        }
        @else {
            <ng-container [ngTemplateOutlet]="component_loading"></ng-container>
        }
    </div>
</div>

<ng-template #component_loaded>
    <form [formGroup]="form!">
        <!-- order -->
        
        <!-- QUESTION 01 -->
        <corp-card [corp-content]="tp_corp_card_q01"></corp-card>
        <div class="mb-5"></div>
        <!-- QUESTION 02 -->
        <corp-card [corp-content]="tp_corp_card_q02"></corp-card>
        <div class="mb-5"></div>
        <!-- QUESTION 03 -->
        <corp-card [corp-content]="tp_corp_card_q03"></corp-card>
        <div class="mb-5"></div>
        <!-- QUESTION RISQUE -->
         <!-- @if(_orderWizardService.orderWizard$()?.step04?.dueDiligenceDto?.question03?.answer?.code=='Q03A02') {
            <corp-card [corp-content]="tp_corp_card_q04"></corp-card>
            <div class="mb-5"></div>
         } -->

        <div [formGroupName]="_orderWizardService.modelNames.step04.key">
            <div [formGroupName]="_orderWizardService.modelNames.step04.fields.dueDiligenceDto.key">
                <h5 class="flex justify-end text-color-primary-500">  
                    
                    <corp-checkbox 
                        [formControlName] = "_orderWizardService.modelNames.step04.fields.dueDiligenceDto.fields.isInformationCertified.key"
                        class="transition-all duration-300 px-4 py-2 text-white rounded"
                        [class.bg-secondary-500]="_orderWizardService.getValue(x=>x.step04?.dueDiligenceDto?.isInformationCertified)"
                        [class.bg-gray-800]="!_orderWizardService.getValue(x=>x.step04?.dueDiligenceDto?.isInformationCertified)"
                        [corp-label]="'i18n.app.features.pages.order.wizard.step_04.due-diligence.checkbox_01' | translate">
                    </corp-checkbox>
                </h5>
            </div>
        </div>
         <!-- @if(_orderWizardService.orderWizard$()?.step03?.customerDto?.nationality?.highRisk){ -->

        <!-- ======== -->
        <!-- TEMPLATES -->
        <!-- ======= -->
        
        <ng-template #tp_corp_card_q01>
            <div [formGroupName]="_orderWizardService.modelNames.step04.key">
            <div class="corp-card">
                <div class="corp-card-header mb-[20px] md:mb-[25px] sm:flex items-center justify-between">
                    <h5 class="!mb-0">
                        {{ _orderWizardService.selection$()?.dueDiligence?.question01?.label }} 
                    </h5>
                    
                    <div 
                        class="h-10 w-10 flex items-center justify-center rounded-full bg-primary-500 shadow-lg shadow-primary text-white">
                        <span class="material-symbols-outlined text-2xl leading-none">
                            contact_support
                        </span>
                    </div>
                </div>

                <div class="corp-card-content" >
                    <div [formGroupName]="_orderWizardService.modelNames.step04.fields.dueDiligenceDto.key">
                        <!-- <div [formGroupName]="_orderWizardService.modelNames.step04.fields.dueDiligenceDto.fields.DueDiligenceDto.key"> -->
                        <div [formGroupName]="_orderWizardService.modelNames.step04.fields.dueDiligenceDto.fields.question01.key">
                            @for (answer of _orderWizardService.selection$()?.dueDiligence?.answer01List; track answer.id) {
                                <!-- TODO begin creer corp-radio -->
                                <label class="relative flex w-full items-center gap-2 cursor-pointer overflow-hidden p-2 rounded hover:bg-secondary-100"
                                    (click)="triggerLaser(answer.id!)">
                                    <input
                                        type="radio"
                                        class="cursor-pointer accent-primary-500"
                                        [value]="answer"
                                        [formControlName]="_orderWizardService.modelNames.step04.fields.dueDiligenceDto.fields.question01.fields.answer.key"
                                    />
                                    <span>{{ answer.label }}</span>

                                    <!-- Laser -->
                                    <span
                                        *ngIf="activeLaser ===answer.id!"
                                        class="absolute top-0 left-0 h-full w-full pointer-events-none" >
                                        <span class="laser"></span>
                                    </span>
                                </label>
                                <!-- TODO end creer corp-radio -->
                            }
                        <!-- </div> -->
                        </div>
                    </div>
                </div>
            </div>
             </div>
        </ng-template>

                
        <ng-template #tp_corp_card_q02>
            <div [formGroupName]="_orderWizardService.modelNames.step04.key">
                <div class="corp-card">
                    <div class="corp-card-header mb-[20px] md:mb-[25px] sm:flex items-center justify-between">
                        <h5 class="!mb-0">
                            {{ _orderWizardService.selection$()?.dueDiligence?.question02?.label }} 
                        </h5>
                        <div 
                            class="h-10 w-10 flex items-center justify-center rounded-full bg-primary-500 shadow-lg shadow-primary text-white">
                            <span class="material-symbols-outlined text-2xl leading-none">
                                contact_support
                            </span>
                        </div>
                    </div>

                    <div class="corp-card-content" >
                        <div [formGroupName]="_orderWizardService.modelNames.step04.fields.dueDiligenceDto.key">
                            <div [formGroupName]="_orderWizardService.modelNames.step04.fields.dueDiligenceDto.fields.question02.key">
                                @for (answer of _orderWizardService.selection$()?.dueDiligence?.answer02List; track answer.id) {
                                    <label class="relative flex w-full items-center gap-2 cursor-pointer overflow-hidden p-2 rounded hover:bg-secondary-100"
                                        (click)="triggerLaser(answer.id!)">
                                        <input
                                            type="radio"
                                            class="cursor-pointer accent-primary-500"
                                            [value]="answer"
                                            [formControlName]="_orderWizardService.modelNames.step04.fields.dueDiligenceDto.fields.question02.fields.answer.key"
                                        />
                                        <span>{{ answer.label }}</span>

                                        @if(activeLaser === answer.id!){
                                            <span
                                                class="absolute top-0 left-0 h-full w-full pointer-events-none" >
                                                <span class="laser"></span>
                                            </span>
                                        }
                                    </label>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #tp_corp_card_q03>
            <div [formGroupName]="_orderWizardService.modelNames.step04.key">
                <div class="corp-card">
                    <div class="corp-card-header mb-[20px] md:mb-[25px] sm:flex items-center justify-between">
                        <h5 class="!mb-0">
                            <!--h5_01 Order ID  -->
                            {{ _orderWizardService.selection$()?.dueDiligence?.question03?.label }} 
                        </h5>
                        
                        <div 
                            class="h-10 w-10 flex items-center justify-center rounded-full bg-primary-500 shadow-lg shadow-primary text-white">
                            <span class="material-symbols-outlined text-2xl leading-none">
                                contact_support
                            </span>
                        </div>
                    </div>

                    <div class="corp-card-content" >
                        <div [formGroupName]="_orderWizardService.modelNames.step04.fields.dueDiligenceDto.key">
                            <div [formGroupName]="_orderWizardService.modelNames.step04.fields.dueDiligenceDto.fields.question03.key">
                                @for (answer of _orderWizardService.selection$()?.dueDiligence?.answer03List; track answer.id) {
                                    
                                    <label class="relative flex w-full items-center gap-2 cursor-pointer overflow-hidden p-2 rounded hover:bg-secondary-100"
                                        (click)="triggerLaser(answer.id!)">
                                        <input
                                            type="radio"
                                            class="cursor-pointer accent-primary-500"
                                            [value]="answer"
                                            [formControlName]="_orderWizardService.modelNames.step04.fields.dueDiligenceDto.fields.question03.fields.answer.key"
                                        />
                                        <span>{{ answer.label }}</span>

                                        <!-- Laser -->
                                        @if(activeLaser === answer.id!){
                                            <span
                                                class="absolute top-0 left-0 h-full w-full pointer-events-none" >
                                                <span class="laser"></span>
                                            </span>
                                        }
                                    </label>
                                }
                            </div>
                        </div>

                        @if(_orderWizardService.orderWizard$()?.step04?.dueDiligenceDto?.question03?.answer?.code=='Q03A02') {
                            <div 
                                class="py-[1rem] px-[1rem] text-white  rounded-md flex items-start gap-[5px] bg-primary-500 border border-primary-800">
                                <i class=" text-[20px] mt-[2px] ri-shield-check-line"></i>
                                <div>
                                    <span class="font-semibold">
                                        {{ 'i18n.app.features.pages.order.wizard.step_04.due-diligence.span_01' | translate }}
                                    </span>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #tp_corp_card_q04>
            <!-- <div [formGroupName]="_orderWizardService.modelNames.step04.key">
                <div class="corp-card">
                    <div class="corp-card-header mb-[20px] md:mb-[25px] sm:flex items-center justify-between">
                        <h5 class="!mb-0">
                            {{ 'i18n.app.features.pages.order.wizard.step_04.due-diligence.h5_01' | translate }} 
                        </h5>
                        
                        <div 
                            class="h-10 w-10 flex items-center justify-center rounded-full bg-primary-500 shadow-lg shadow-primary text-white">
                            <span class="material-symbols-outlined text-2xl leading-none">
                                policy_alert
                            </span>
                        </div>
                    </div>

                    <div class="corp-card-content" >
                        <div [formGroupName]="_orderWizardService.modelNames.step04.fields.dueDiligenceDto.key">
                            <div [formGroupName]="_orderWizardService.modelNames.step04.fields.dueDiligenceDto.fields.additionalQuestions.key">
                                <div [formGroupName]="_orderWizardService.modelNames.step04.fields.dueDiligenceDto.fields.additionalQuestions.fields.question01.key">
                                    <corp-textarea
                                        corp-size="xl"
                                        [corp-label]="_orderWizardService.selection$()?.dueDiligence?.question05?.label!"
                                        [formControlName]="_orderWizardService.modelNames.step04.fields.dueDiligenceDto.fields.additionalQuestions.fields.question01.fields.answer.key">
                                    </corp-textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
        </ng-template>
    </form>
</ng-template>

<ng-template #component_loading>
    <corp-loading></corp-loading>
</ng-template>